import { useState } from "react"

import { useTranslation } from "react-i18next"

import { ChevronDown, CircleCheck, Globe } from "@/components/icons"
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu"
import { enabledLanguageCodes, SUPPORTED_LANGUAGES } from "@/lib/languages"
import { SettingsService } from "@/services/settings-service"

export function LanguageSwitcher() {
  const [settingsService] = useState<SettingsService>(SettingsService.getInstance())
  const { i18n } = useTranslation()

  const enabled = enabledLanguageCodes()
  const languages = SUPPORTED_LANGUAGES.filter((language) => enabled.includes(language.code))

  const handleLanguageChange = async (languageCode: string) => {
    await i18n.changeLanguage(languageCode)

    // Update the language in the stored settings
    const newSettings = await settingsService.getActiveSettings()
    newSettings.languageCode = languageCode
    await settingsService.setActiveSettings(newSettings)
  }

  // Filter out the current language from the options
  const currentLanguage = languages.find((lang) => lang.code === i18n.language)

  return (
    <DropdownMenu>
      <DropdownMenuTrigger className="text-sidebar-foreground hover:bg-sidebar-accent hover:text-sidebar-accent-foreground flex w-fit items-center gap-3 rounded-sm p-1 px-2">
        <Globe className="size-5 shrink-0" />
        <p className="">{currentLanguage?.label}</p>
        <ChevronDown className="size-5 shrink-0" />
      </DropdownMenuTrigger>
      <DropdownMenuContent>
        {languages.map((lang) => (
          <DropdownMenuItem
            key={lang.code}
            className="group flex items-center justify-between"
            onClick={async (e) => {
              e.stopPropagation()
              await handleLanguageChange(lang.code)
            }}
          >
            {lang.label}
            {lang.code === currentLanguage?.code && (
              <CircleCheck className="text-foreground dark:group-hover:text-background size-5 shrink-0 stroke-[2px]" />
            )}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
